module.exports = "/_next/static/images/1c522acc5a5fa7b9eda03f5eea44ec84-mgm-lg-2x-v2.jpg";